<template>
<div class="row" :class="_class">
    <slot></slot>
</div>
</template>

<script>
export default {
    props: {
        alignment: {
            type: Object,
            default: function() {
                return {
                    ver: [], // start|center|end
                    hor: [], // start|center|end|around|between
                }
            }
        }
    },
    computed: {
        _class: function() {
            let _class = []

            if(this.alignment['ver'].length) {
                this.alignment['ver'].forEach(ver => {
                    _class.push('align-items-'+ver)
                });
            }

            if(this.alignment['hor'].length) {
                this.alignment['hor'].forEach(hor => {
                    _class.push('justify-content-'+hor)
                });
            }

            return _class
        }
    },
}
</script>